import { useState, useEffect } from "react";
import { Logo } from "@/components/landing/Logo";

const links = [
  { label: "Services", href: "/#services" },
  { label: "Work", href: "/#work" },
  { label: "Contact", href: "/#contact" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 backdrop-blur-xl ${
        scrolled
          ? "bg-white/80 border-b border-[#122A1D]/10 py-3"
          : "bg-transparent border-b border-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between">
        <a href="/" data-testid="header-logo-link">
          <Logo compact={scrolled} />
        </a>
        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm uppercase tracking-[0.2em] text-[#3E5247] hover:text-[#A9842F] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
          <a
            href="/#contact"
            data-testid="header-cta-button"
            className="bg-[#C8A24A] text-[#0B1F16] hover:bg-[#B8923D] font-semibold transition-colors duration-300 px-6 py-2.5 text-sm uppercase tracking-wider"
          >
            Get a Quote
          </a>
        </nav>
        <a
          href="/#contact"
          data-testid="header-cta-mobile"
          className="md:hidden bg-[#C8A24A] text-[#0B1F16] font-semibold px-4 py-2 text-xs uppercase tracking-wider"
        >
          Quote
        </a>
      </div>
    </header>
  );
};
